/* import __COLOCATED_TEMPLATE__ from './web.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();